module.exports = __webpack_public_path__ + "static/img/wuliusudi.446bddd7.png";